export const nihApiTypes = {
  NIH_CONDITIONS: 'NIH_CONDITIONS',
  NIH_RXTERMS: 'NIH_RXTERMS',
  NIH_PROCEDURES: 'NIH_PROCEDURES',
  NIH_DIAGNOSIS: 'NIH_DIAGNOSIS'
};

export default { nihApiTypes };
